import React from "react";
import NotFoundGif from "assets/404.gif";

function NotFound() {
  return (
    <div className="flex items-center justify-center h-screen w-screen relative">
      <div className="w-full md:w-[500px] h-full relative flex justify-center items-center">
        <iframe
          title="notfound"
          src={NotFoundGif}
          className="w-[400px] h-[600px] md:w-[400px] md:h-[600px] object-contain"
          frameBorder="1"
        ></iframe>
      </div>
    </div>
  );
}

export default NotFound;
